import Vue from 'vue'
import Router from 'vue-router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import home from '@/pages/home/home'
import wenda from '@/pages/wenda/wenda'
import eventlist from '@/pages/eventlist/eventlist'
import addevent from '@/pages/eventlist/addevent'
import paihangbang from '@/pages/paihangbang/paihangbang'
import userresult from '@/pages/userresult/userresult'
import cuotiji from '@/pages/cuotiji/cuotiji'
import login from '@/pages/login/login'
import register from '@/pages/register/register'
import editor from '@/pages/editor/editor'
import elementui from '@/pages/elementui/elementui'
import myecharts from '@/pages/myecharts/myecharts'
import admin from '@/pages/admin/admin'
import catelist from '@/pages/visitorcate/catelist'
import fieldlist from '@/pages/fields/fieldlist'
import addemailtemp from '@/pages/emailtemp/addemailtemp'
import emailtemplist from '@/pages/emailtemp/emailtemplist'
import badgelist from '@/pages/badgelist/badgelist'
import addbadge from '@/pages/badgelist/addbadge'
import visitorlist from '@/pages/visitors/visitorlist'
import general from '@/pages/general/general'
import checkin from '@/pages/general/checkin'
import regfinish from '@/pages/home/regfinish'
import selectcate from '@/pages/home/selectcate'
import payment from '@/pages/home/payment'
import promocodelist from '@/pages/home/PromoCode/PromoCodelist'
import suggestion from '@/pages/suggestions/suggestion'
import suglist from '@/pages/suggestions/suglist'
import mysug from '@/pages/suggestions/mysug'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'suggestion',
      component: suggestion,
      meta:{
        auth:false,
        title:'金园超市意见建议反馈'
      }
    },
    {
      path: '/suggestion',
      name: 'suggestion',
      component: suggestion,
      meta:{
        auth:false,
        title:'金园超市意见建议反馈'
      }
    },
    {
      path: '/suglist',
      name: 'suglist',
      component: suglist,
      meta:{
        auth:false,
        title:'金园超市意见建议公示台'
      }
    },
    {
      path: '/mysug',
      name: 'mysug',
      component: mysug,
      meta:{
        auth:false,
        title:"我的建议"
      }
    },
    {
      path: '/home',
      name: 'home',
      component: home,
      meta:{
        auth:false
      }
    },
    {
path:'/promocodelist',
name:'promocodelist',
component:promocodelist
    },
    {
      path: '/reg',
      name: 'home',
      component: home,
      meta:{
        auth:false
      }
    },
    {
      path: '/regfinish',
      name: 'regfinish',
      component: regfinish,
      meta:{
        auth:false
      }
    },
    {
      path: '/selectcate',
      name: 'selectcate',
      component: selectcate,
      meta:{
        auth:false
      }
    },
    {
      path: '/payment',
      name: 'payment',
      component: payment,
      meta:{
        auth:false
      }
    },
    {
      path: '/checkin',
      name: 'checkin',
      component: checkin
    },
    {
      path: '/general',
      name: 'general',
      component: general
    },
    {
      path: '/visitorlist',
      name: 'visitorlist',
      component: visitorlist
    },
    {
      path: '/eventlist',
      name: 'eventlist',
      component: eventlist
    },
    {
      path: '/addemailtemp',
      name: 'addemailtemp',
      component: addemailtemp
    },
    {
      path: '/emailtemplist',
      name: 'emailtemplist',
      component: emailtemplist
    },
    {
      path: '/addbadge',
      name: 'addbadge',
      component: addbadge
    },
    {
      path: '/admin',
      name: 'admin',
      component: badgelist
    },
    {
      path: '/badgelist',
      name: 'badgelist',
      component: badgelist
    },
    {
      path: '/fieldlist',
      name: 'fieldlist',
      component: fieldlist
    },
    {
      path: '/catelist',
      name: 'catelist',
      component: catelist
    },
    {
      path: '/wenda',
      name: 'wenda',
      component: wenda
    },
    {
      path: '/paihangbang',
      name: 'paihangbang',
      component: paihangbang
    },
    {
      path: '/result',
      name: 'result',
      component: userresult
    },
    {
      path: '/cuotiji',
      name: 'cuotiji',
      component: cuotiji
    },
    {
      path: '/login',
      name: 'login',
      component: login,
      meta:{
        auth:false
      }
    },
    {
      path: '/register',
      name: 'register',
      component: register
    },
    {
      path: '/editor/:id?',
      name: 'editor',
      component: editor
    },
    {
      path: '/elementui',
      name: 'elementui',
      component: elementui
    },
    {
      path: '/myecharts',
      name: 'myecharts',
      component: myecharts
    },
    // {
    //   path: '/admin',
    //   name: 'admin',
    //   component: admin
    // },
    {
      path: '/addevent',
      name: 'addevent',
      component: addevent
    }
  ]
})

router.beforeEach((to, from, next) => {
  console.log('beforeEach')
  console.log(to.meta)
  console.log(to.meta.auth)
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if(to.meta.auth==undefined || to.meta.auth!=false){
    var userJson = localStorage.getItem('userJson');
    console.log(userJson);
    if(userJson!=undefined && userJson!=null){
      NProgress.start()
      next()
    }else{
      next({
        path:'/login'
      })
    }
  }else{
    NProgress.start()
      next()
  }
})

router.afterEach((to, from) => {
  console.log('afterEach')
  NProgress.done()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js